<div class="social-media-share">
    <div *ngIf="!disableHeader" class="socials-share-header">{{"general.share" | translate:urlService.lang}}:</div>

    <ul class="socials-list socials-aside">
        <li class="socials-item">
            <a class="socials-link socials-facebook" href="{{getSocialLink('facebook')}}" rel="nofollow"
               target="_blank">Facebook</a>
        </li>
        <li class="socials-item">
            <a class="socials-link socials-twitter" href="{{getSocialLink('twitter')}}" rel="nofollow" target="_blank">Twitter</a>
        </li>
        <li class="socials-item">
            <a class="socials-link socials-pinterest" href="{{getSocialLink('pinterest')}}" rel="nofollow"
               target="_blank">Pinterest</a>
        </li>
        <li *ngIf="!disableEmail" class="socials-item">
            <a (click)="onEmailClick($event); false" class="socials-link socials-email" href="#"></a>
        </li>
        <li *ngIf="enableFbLike" class="socials-item">
            <div class="fb-like-wrapper">
                <fb-like colorScheme="dark" href="{{sharedUrl}}" layout="button" size="large" width="79"></fb-like>
            </div>
        </li>
    </ul>
</div>
